class SliderContainer extends HTMLElement {
  constructor() {
    super();
    window.onload = () => {
      this.scrollToContact();
      this.slides = this.querySelectorAll('.slider');
      this.currentSlide = 0;

      this.slides.forEach((slide, i) => {
        slide.style.transform = `translateX(${i * 100}%)`;
      });

      this.slideInterval = setInterval(() => this.slideNext(), 3000);
    };
  }

  slideNext() {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;

    const translate = `translateX(${this.currentSlide * -100}%)`;
    this.slides.forEach((slide) => {
      slide.style.transform = translate;
    });
  }
  scrollToContact() {
    this.bannerSliderBtn = this.querySelector('.image-banner-slider__scroll');
    if (this.bannerSliderBtn && this.bannerSliderBtn.classList.contains('image-banner-slider__scroll')) {
      this.bannerSliderBtn.addEventListener('click', (event) => {
        event.preventDefault();
        this.scrollTowards(event.target);
      });
    } else {
      console.log('console.log');
    }
  }
  scrollTowards(button) {
    const sectionId = button.getAttribute('href');
    const section = document.querySelector(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

customElements.define('slider-container', SliderContainer);
